module.exports = __webpack_public_path__ + "img/supplies-no-image.d5dd2fad.png";